import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular'
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;

  constructor(
    private storage: Storage
  ) { 
    this.init();
  }

  get store() {
    return this._storage;
  }

  async init() {
    const storage = await this.storage.create();
    this._storage = storage;
  }

  public set(key: string, value: any){
    this._storage?.set(key, value);
  }

  public get(key: string){
    return this._storage?.get(key);
  }

  public remove(key:string){
    this._storage?.remove(key);
  }

  public clearStorage(){
    this._storage?.clear();
  }

  public async getToken(): Promise<string> {
    let token = await this._storage?.get('token');
    return token || '';
  }

  isAuthenticated(): Promise<string>|undefined {
    return this._storage?.get('token');
  }

  public async getRole() {
    return await this._storage?.get('role');
  }

  public async getUser() { 
    let user = await this._storage?.get("user");
    return user || null;
  }
}
